import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import trJson from "./locales/tr.json";
import enJson from "./locales/en.json";

// Uygulama veya harici linklerden ?lang= parametresi ile dil desteği (ilk yüklemede)
const getInitialLang = (): string => {
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    const langParam = params.get("lang");
    if (langParam === "tr" || langParam === "en") return langParam;
  }
  return "tr";
};

i18n.use(initReactI18next).init({
  resources: {
    en: enJson,
    tr: trJson,
  },
  fallbackLng: "tr",
  lng: getInitialLang(),
  supportedLngs: ["tr", "en"],
  load: "languageOnly",
  interpolation: {
    escapeValue: false,
  },
  defaultNS: "translation",
});

export default i18n;
